<script>
import RTabs from '@/components/ResourceDialog/RTabs.vue'
import ResourceFooter from './ResourceFooter.vue'
import FolderAndResourceElement from './FolderAndResourceElement.vue'
import FilePreviewElement from './FilePreviewElement.vue'
import SegmentedControl from '@/components/SegmentedControl.vue'
import FileElement from './FileElement.vue'
import SwitchTextbookDialog from './SwitchTextbookDialog.vue'
import ResourceEmpty from './ResourceEmpty.vue'

import { getFileStorage, getStorageFolder, getStorageFolderNumber, postFileStorage, deleteResource, renameResourceOrFolder, moveResourceToFolder } from '../../api/resource'
import _ from 'lodash'
import { fileDataManage } from '@/observable'
import { useRotateAndScale } from '@/hooks/useRotateAndScale'

export default {
  name: 'ResourcesDialog',
  components: { FolderAndResourceElement, RTabs, ResourceFooter, FileElement, SegmentedControl, SwitchTextbookDialog, ResourceEmpty },
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    fileType: {
      type: String,
      validator: (/** @type {string} */ value) => ['', 'video', 'image', 'audio'].includes(value),
      default: '',
      required: true
    }
  },
  data() {
    return {
      newFolderDialogVisible: false,
      renameDialogVisible: false,
      renameValue: '',
      remoteFolderOptions: [],
      moveFolderValue: undefined,
      fetchRemoteFolderLoading: false,
      newFolderName: '',
      moveFolderDialogVisible: false,
      enterEditorMode: false,
      switchTextbookDialogVisible: false,
      tipsAnimation: () => { },
      loading: true,
      typeMap: {
        1: ['图片', 'image'],
        2: ['音频', 'audio'],
        3: ['视频', 'video'],
        image: 1,
        audio: 2,
        video: 3
      },
      folderArr: [],
      folderID: undefined,
      isFolderOwner: false,
      folderPagination: {
        page: 1,
        size: 15,
        total: 0,
        title: ''
      },
      sourcePagination: {
        page: 1,
        total: 0,
        title: '',
        sortBy: 'time'
      },
      diskSpace: {},
      numResArr: [],
      directoryValue: 'all',
      directoryOptions: [
        { label: '目录', value: 'ml', disabled: true },
        { label: '全部', value: 'all', disabled: false },
      ],
      school_stage: null,
      // 当前选中的出版社
      publisher: null,
      // 当前选中的教材
      textbookInfo: null,
      textbookDirectoryId: undefined,
      directoryChainPath: {chainIdPath: [], chainName: '全部'},
    }
  },
  computed: {
    bookName() {
      return this.textbookInfo && this.directoryValue === 'ml' ? this.textbookInfo.text_name : '全部'
    },
    fileDataManage() {
      return fileDataManage
    },
    show: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    },
    theFiletype: {
      get() {
        return this.fileType
      },
      set(val) {
        // this.loading = true
        // this.$emit('update:fileType', val)
        // this.getFatch(val)
      }
    },
    tabsArr() {
      return this.numResArr.reduce((acc, cur) => {
        if (cur.file_type === 0) {
          return acc
        }
        if (this.typeMap[this.typeMap[this.fileType]][1] === this.typeMap[cur.file_type][1]) {
          acc = [
            ...acc,
            {
              label: this.typeMap[cur.file_type][0],
              name: this.typeMap[cur.file_type][1],
              len: cur.number
            }
          ]
        }
        return acc
      }, [])
    },
    disabledMoveBtn() {
      const bool =
        !this.fileDataManage.checkedList.length ||
        (this.fileDataManage.checkedList.length && this.fileDataManage.checkedList.some(x => x.is_folder === 1))
      return bool
    },
    disabledDeleteBtn() {
      return !this.fileDataManage.checkedList.length
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.tipsAnimation = useRotateAndScale(this.$refs.switchTextbookBtn)
    })
  },
  watch: {
    directoryValue(val) {
      this.getFatch(this.fileType)
    },
    visible: {
      handler(val) {
        if (val) {
          this.getFatch(this.fileType)
          this.fetchFolderDiskSpace()
        }
      },
      immediate: true
    },
    folderID: {
      handler(val) {
        if (val) {
          this.loading = true
          this.sourcePagination.page = 1 // 重置一下页码
          this.getFolderContent(val)
        } else {
          /* 清空文件列表数据和选中的文件 id */
          this.fileDataManage.checkedList = []
          this.fileDataManage.fileArr = []
        }
        this.fetchFolderDiskSpace()
      }
    },
    'folderPagination.title': {
      handler: _.debounce(function () {
        this.$nextTick(() => {
          this.getFatch(this.fileType)
        })
      }, 100)
    },
    'sourcePagination.sortBy': {
      handler: _.debounce(function () {
        this.$nextTick(() => {
          this.folderPagination.page = 1
          this.getFolderContent(this.folderID)
        })
      }, 100)
    },
    'sourcePagination.title': {
      handler: _.debounce(function () {
        this.$nextTick(() => {
          this.getFolderContent(this.folderID)
        })
      }, 100)
    },
    textbookDirectoryId(val) {
      if (val) {
        this.getFatch(this.fileType)
      }
    },
  },
  methods: {
    getDirectoryChainPath() {
      if (this.textbookInfo && this.textbookDirectoryId && this.directoryValue === 'ml') {
        const reslut = this.deepLoop(this.textbookInfo.directory, this.textbookDirectoryId)
        if(reslut) {
          return reslut
        }
      }
      return {chainIdPath: [], chainName: '全部'}
    },
    deepLoop(directory, id) {
      for (const item of directory) {
        if (item.children && item.children.length > 0) {
          const res = this.deepLoop(item.children, id)
          if (res) {
            const { chainIdPath, chainName } = res
            return {
              chainIdPath: [item.id, ...chainIdPath],
              chainName: `${item.direct_name} / ${chainName}`
            }
          }
        } else {
          if (item.id === id) {
            return { chainIdPath: [item.id], chainName: item.direct_name }
          }
        }
      }
    },
    // 获取远程文件夹列表，用于资源迁移选择
    fetchRemoteFolder(query) {
      this.fetchRemoteFolderLoading = true
      const params = {
        fb_file_type: this.typeMap[this.fileType],
        fu_origin_filename: query,
        fb_subject_id: +this.$route.query.subjectId || 1,
        fb_scope_type: 1,
        is_folder: 1,
        page: 1,
        page_size: 50,
      }
      if (this.publisher) params.fb_publisher_id = this.publisher.id
      if (this.textbookInfo) params.fb_textbook_id = this.textbookInfo.id
      if (this.textbookDirectoryId) params.fb_dict_id = this.textbookDirectoryId
      getFileStorage(params).then(res => {
        this.remoteFolderOptions = res.data.filter(x => x.is_folder === 1)
      }).finally(() => {
        this.fetchRemoteFolderLoading = false
      })
    },
    handleConfirmNewFolder() {
      console.log(this.newFolderName, '创建文件夹api调用')
      postFileStorage({
        dict_id: this.textbookDirectoryId,
        dict_ids: [this.textbookDirectoryId],
        file_type: this.typeMap[this.fileType],
        is_folder: true,
        is_public: 1,
        origin_filename: this.newFolderName,
        publisher_id: this.publisher.id,
        subject_id: this.$route.query.subjectId || 1
      })
        .then(res => {
          this.$message.success('创建文件夹成功')
          this.getFatch(this.fileType)
        })
        .catch(err => {
          this.$message.error(err)
        })
        .finally(() => {
          this.newFolderDialogVisible = false
          this.newFolderName = ''
        })

    },
    handleConfirmRename() {
      Promise.all(this.fileDataManage.checkedList.map(x => {
        return renameResourceOrFolder(x.id, this.renameValue)
      }))
        .then(res => {
          this.$message.success('重命名成功')
          this.refreshFolderContent()
        })
        .catch(err => {
          this.$message.error(err)
        })
        .finally(() => {
          this.renameDialogVisible = false
        })
    },
    handleConfirmMoveFolder() {
      moveResourceToFolder(this.fileDataManage.checkedList.map(x => x.id), this.moveFolderValue)
        .then(res => {
          this.$message.success('移动成功')
          this.getFatch(this.fileType)
        })
        .catch(err => {
          this.$message.error(err)
        })
        .finally(() => {
          this.moveFolderDialogVisible = false
        })
    },
    editorBtnHandle(type) {
      if (type === 'newFolder') {
        if (this.directoryValue === 'all') {
          this.$message.warning('如需新建文件夹，请先点击左下方按钮关联对应的课件目录后再创建')
          this.tipsAnimation()
          return
        }
        this.newFolderDialogVisible = true
      }
      if (type === 'delete') {
        let tipsStr = '该操作将会删除多媒体资源，是否继续？'
        const hasFolderArr = this.fileDataManage.checkedList.filter(x => x.is_folder)
        if (hasFolderArr.length > 0) {
          tipsStr = `该操作将会删除该文件夹，其中包括文件夹内的多媒体资源。是否继续？`
        }
        const hasUsedArr = this.fileDataManage.checkedList.filter(x => x.is_used)
        if (hasUsedArr.length > 0) {
          tipsStr = `<b style="color: red">${hasUsedArr.map(x => x.origin_filename).join('、')}</b> 资源已被其他课件引用，删除后将会对其他课件产生影响，是否继续？`
        }
        this.$confirm(tipsStr, '温馨提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          dangerouslyUseHTMLString: true,
          type: 'warning'
        }).then(() => {
          deleteResource(this.fileDataManage.checkedList.map(x => x.id))
            .then(res => {
              this.$message.success('删除成功')
              this.getFatch(this.fileType)
            })
            .catch(err => {
              this.$message.error(err)
            })
        })
      }
      if (type === 'rename') {
        if (this.fileDataManage.checkedList.length === 1) {
          this.renameValue = this.fileDataManage.checkedList[0].origin_filename
        } else {
          this.renameValue = ''
        }
        this.renameDialogVisible = true
      }
      if (type === 'enterEdit') {
        this.enterEditorMode = true
      }
      if (type === 'exitEdit') {
        this.enterEditorMode = false
        this.fileDataManage.checkedList = []
      }
      if (type === 'moveFolder') {
        this.moveFolderDialogVisible = true
      }
    },
    getTreeLastChildNodeId(node) {
      if(!node) return undefined
      if (node.children && node.children.length > 0) {
        return this.getTreeLastChildNodeId(node.children[0])
      } else {
        return node.id
      }
    },
    handleNodeClick(node) {
      // 如果当前点击的节点是当前教材的最后一级目录，则选中该节点
      console.log(this.fileDataManage)
      if (this.textbookInfo.dict_level === node.level && this.textbookDirectoryId !== node.id) {
        this.directoryChainPath = this.getDirectoryChainPath() // 更新当前章节路径
        this.editorBtnHandle('exitEdit') // 退出编辑模式
        this.fileDataManage.checkedList = [] // 切换目录时，清空勾选的文件
        this.fileDataManage.fileArr = [] // 切换目录时，清空文件列表
        this.folderID = undefined // 切换目录时，清空文件夹id
        this.textbookDirectoryId = node.id // 赋值选中目录id，触发 watch
      }
    },
    folderAndResourceHandle(item) {
      console.log(this.folderArr, 'folderArr')
      // 点击的是文件夹
      if (item.is_folder === 1) {
        this.folderID = item.id
        this.isFolderOwner = item.is_owner
      }
      else {
        this.$createFilePreview(FilePreviewElement, { item })
      }
    },
    handleSwitchTextbook() {
      this.switchTextbookDialogVisible = true
    },
    /**
     * 资源获取函数
     * @param t 文件类型
     */
    getFatch(t) {
      this.loading = true
      this.fetchDataNumber(this.directoryValue === 'all')
      this.fetchFolder(t)
    },
    getFatchStorage(id) {
      this.loading = true
      this.getFolderContent(id)
      this.fetchDataNumber()
    },
    /**
     * 刷新内容
     */
    refreshFolderContent() {
      if (this.folderID) {
        this.loading = true
        // 如果是在文件夹内部，根据当前的文件夹id，重新获取文件夹的内容
        this.getFolderContent(this.folderID)
      } else {
        // 如果是在目录，刷新当前目录的内容
        this.getFatch(this.fileType)
      }
    },
    /**
     * 根据文件夹 id 获取里面的文件
     * @param id 文件夹id
     */
    async getFolderContent(id) {
      const res = await getFileStorage({
        folder_id: id,
        fb_file_type: this.typeMap[this.fileType],
        fu_origin_filename: this.sourcePagination.title,
        fb_subject_id: +this.$route.query.subjectId || 1,
        page: this.sourcePagination.page,
        fb_scope_type: 1,
        page_size: 15,
        sort_by: this.sourcePagination.sortBy
      })
      if (!this.folderID) {
        this.folderArr = res.data
      }
      this.fileDataManage.fileArr = res.data
      this.sourcePagination.total = res.meta.total
      this.loading = false
    },
    /**
     * 获取图片、视频、音频三个 tabs 的 total
     * @param isAll 是否全部
     */
    async fetchDataNumber(isAll) {
      const params = {
        fb_subject_id: +this.$route.query.subjectId || 1,
        fu_origin_filename: '',
        page: 1,
        is_public: 1,
        page_size: 9999,
      }
      if (this.folderID) {
        params.fu_origin_filename = this.sourcePagination.title
      } else {
        params.fu_origin_filename = this.folderPagination.title
      }
      if (this.publisher && !isAll) params.fb_publisher_id = this.publisher.id
      if (this.textbookInfo && !isAll) params.fb_textbook_id = this.textbookInfo.id
      if (this.textbookDirectoryId && !isAll) params.fb_dict_id = this.textbookDirectoryId
      this.numResArr = await getStorageFolderNumber(params)
    },
    /**
     * 获取当前类型下的全部文件夹以及资源
     */
    async fetchFolder(t) {
      const params = {
        fb_file_type: this.typeMap[t],
        fu_origin_filename: this.folderPagination.title,
        fb_subject_id: +this.$route.query.subjectId || 1,
        page: this.folderPagination.page,
        page_size: this.folderPagination.size,
        sort_by: this.sourcePagination.sortBy
      }
      if (this.publisher && this.directoryValue !== 'all') params.fb_publisher_id = this.publisher.id
      if (this.textbookInfo && this.directoryValue !== 'all') params.fb_textbook_id = this.textbookInfo.id
      if (this.textbookDirectoryId && this.directoryValue !== 'all') params.fb_dict_id = this.textbookDirectoryId
      const res = await getStorageFolder(params)
      this.folderArr = res.data
      this.fileDataManage.fileArr = res.data?.filter(x => !x.is_folder)
      this.folderPagination.total = res.meta.total
      this.loading = false
    },
    // 获取云空间
    async fetchFolderDiskSpace() {
      // this.diskSpace = await getDiskSpace()
    },
    handleSelectTextbook(textbook, publisher, school_stage) {
      this.folderID = undefined
      this.directoryValue = 'ml'
      this.directoryOptions[0].disabled = false
      this.school_stage = school_stage
      this.publisher = publisher
      this.textbookInfo = textbook
      // this.textbookDirectoryId = textbook?.directory?.[0]?.id
      this.textbookDirectoryId = this.getTreeLastChildNodeId(textbook?.directory?.[0])
      this.directoryChainPath = this.getDirectoryChainPath()
    },
  }
}
</script>

<template>
  <div>
    <el-dialog
    title="多媒体"
    customClass="ResourcesDialogCustomClass"
    :visible.sync="show"
    :destroy-on-close="true"
    :close-on-click-modal="false" v-bind="$attrs"
    >
      <template #title>
        <div class="titleBox">
          <div class="titleName">
            多媒体
          </div>
          <div class="searchBox">
            <InputTopTip v-if="!folderID" placeholder="按资源名称搜索" v-model="folderPagination.title">
              <el-input placeholder="" v-model="folderPagination.title" clearable
              suffix-icon="el-icon-search"></el-input>
            </InputTopTip>
            <InputTopTip v-else placeholder="按资源名称搜索" v-model="sourcePagination.title">
              <el-input  placeholder="" v-model="sourcePagination.title" clearable
              suffix-icon="el-icon-search"></el-input>
            </InputTopTip>
          </div>
        </div>
      </template>
      <div class="resourceMain">
        <div class="leftBox">
          <div style="padding: 6px 18px 7px 10px; border-bottom: 1px solid #e7e7e7;">
            <SegmentedControl v-model="directoryValue" :options="directoryOptions" />
          </div>
          <div class="treeBox" v-if="textbookInfo && directoryValue === 'ml'">
            <el-tree :data="textbookInfo.directory" ref="treeRef" node-key="id" default-expand-all
              :props="{ label: 'direct_name', children: 'children' }" @node-click="handleNodeClick">
              <div slot-scope="{ node, data }">
                <span :class="{ 'is-current': data.id === textbookDirectoryId }">{{ node.label }}</span>
              </div>
            </el-tree>
          </div>
          <div class="switch-textbook-btn">
            <div ref="switchTextbookBtn" class="btn" @click="handleSwitchTextbook">
              <img src="@/assets/icons/resourceIcon/switch-textbook.png" alt="切换教材">
              <span class="textbookName" :title="bookName">{{ bookName }}</span>
            </div>
          </div>
        </div>
        <div class="mainBox" v-loading="loading">
          <div class="mainBoxTop">
            <span class="backToFolder" v-show="folderID" @click="folderID = undefined"><i
                class="el-icon-back"></i>返回</span>
            <RTabs v-show="!folderID" :active.sync="theFiletype">
              <el-tab-pane v-for="item in tabsArr" :label="`${item.label}(${item.len})`" :name="item.name"
                :key="item.name"></el-tab-pane>
            </RTabs>
            <div class="editBtnBox">
              <div class="editModeBtn" :style="`transform: rotate3d(0, 1, 0, ${enterEditorMode ? 0 : -90}deg)`">
                <el-button plain icon="el-icon-edit" size="small" :disabled="fileDataManage.checkedList.length === 0"
                  @click="editorBtnHandle('rename')">重命名</el-button>

                <el-button plain size="small" :disabled="disabledMoveBtn" @click="editorBtnHandle('moveFolder')">
                  <img class="selfIcon" :src="require('@/assets/image/folder-move.png')" alt="移动文件夹" /> 移动
                </el-button>

                <el-button plain icon="el-icon-delete" size="small" :disabled="disabledDeleteBtn"
                  @click="editorBtnHandle('delete')">删除</el-button>

                <el-button plain size="small" @click="editorBtnHandle('exitEdit')">
                  <img class="selfIcon" :src="require('@/assets/image/folder-edit-back.png')" alt="退出" /> 退出
                </el-button>
              </div>
              <div class="notEditModeBtn" :style="`transform: rotate3d(0, 1, 0, ${enterEditorMode ? 90 : 0}deg)`">
                <el-select
                  v-if="!folderID"
                  v-model="sourcePagination.sortBy"
                  size="small" placeholder="排序方式"
                  :style="`width: ${sourcePagination.sortBy === 'time' ? 115 : 125}px;`"
                >
                  <el-option label="按时间排序" value="time"></el-option>
                  <el-option label="按文件夹排序" value="folder"></el-option>
                </el-select>
                <el-button v-show="!folderID" plain icon="el-icon-folder-add" size="small"
                  @click="editorBtnHandle('newFolder')">新建</el-button>
                <el-button plain type="primary" icon="el-icon-edit-outline" size="small"
                  @click="editorBtnHandle('enterEdit')">编辑</el-button>
              </div>
            </div>
          </div>
          <div id="folderBoundaries" v-show="!folderID" class="flex1">
            <template v-if="folderArr.length > 0">
              <FolderAndResourceElement v-for="item in folderArr" :key="item.id" :item="item"
              :enterEditorMode="enterEditorMode" @resourceClick="folderAndResourceHandle">
            </FolderAndResourceElement>
            </template>
            <template v-else>
              <ResourceEmpty />
            </template>
          </div>
          <div v-show="folderID" class="flex1 fileBox">
            <template v-if="fileDataManage.fileArr.length > 0">
              <div class="flex1" _mb="20px">
                <FileElement :fileList="fileDataManage.fileArr" :class="`fileElement_${fileType}`"></FileElement>
              </div>
            </template>
            <template v-else>
              <ResourceEmpty />
            </template>
          </div>
          <div _flex="~ items-center justify-end" style="margin-top: 15px;">
            <!--		文件夹分页		-->
            <el-pagination v-if="!folderID" background layout="prev, pager, next" :total="folderPagination.total"
              :current-page="folderPagination.page" :page-size="folderPagination.size" @current-change="page => {
                folderPagination.page = page
                getFatch(fileType)
              }
                "></el-pagination>
            <!--		资源分页		-->
            <el-pagination v-else background layout="prev, pager, next" :total="sourcePagination.total" @current-change="page => {
              sourcePagination.page = page
              getFatchStorage(folderID)
            }
              "></el-pagination>
          </div>
        </div>
      </div>
      <ResourceFooter
        :diskSpace="diskSpace"
        :isFolderOwner="isFolderOwner"
        :folderID="folderID"
        :textbookInfo="textbookInfo"
        :directoryId="textbookDirectoryId"
        :directoryValue="directoryValue"
        :fileType="typeMap[fileType]"
        :directoryChainPath="directoryChainPath"
        @refreshFolder="refreshFolderContent" @tipsAnimation="tipsAnimation">
      </ResourceFooter>
    </el-dialog>
    <SwitchTextbookDialog :visible.sync="switchTextbookDialogVisible" @selectTextbook="handleSelectTextbook" />
    <!-- 新建文件夹弹窗 -->
    <el-dialog width="400px" :visible.sync="newFolderDialogVisible" :destroy-on-close="true"
      :close-on-click-modal="false">
      <template #title>
        <div class="titleBox">
          <div class="titleName" style="border: none;">新建文件夹</div>
        </div>
      </template>
      <div>
        <div style="padding: 20px 40px">
          <el-input v-model="newFolderName" placeholder="请输入文件夹名称"></el-input>
        </div>
        <div _flex="~ items-center justify-around" style="margin-bottom: 20px;">
          <el-button style="width:120px" @click="newFolderDialogVisible = false; newFolderName = ''">取消</el-button>
          <el-button style="width:120px" type="primary" @click="handleConfirmNewFolder">确认</el-button>
        </div>
      </div>
    </el-dialog>
    <!-- 重命名弹窗 -->
    <el-dialog width="400px" :visible.sync="renameDialogVisible" :destroy-on-close="true" :close-on-click-modal="false">
      <template #title>
        <div class="titleBox">
          <div class="titleName" style="border: none;">{{ fileDataManage.checkedList.length > 1 ? '批量' : '' }}重命名</div>
        </div>
      </template>
      <div>
        <div style="padding: 20px 40px">
          <el-input v-model="renameValue" placeholder="请输入名称"></el-input>
        </div>
        <div _flex="~ items-center justify-around" style="margin-bottom: 20px;">
          <el-button style="width:120px" @click="renameDialogVisible = false">取消</el-button>
          <el-button style="width:120px" type="primary" @click="handleConfirmRename">确认</el-button>
        </div>
      </div>
    </el-dialog>
    <!-- 移动文件夹弹窗 -->
    <el-dialog width="400px" :visible.sync="moveFolderDialogVisible" :destroy-on-close="true"
      :close-on-click-modal="false">
      <template #title>
        <div class="titleBox">
          <div class="titleName" style="border: none;">迁移至</div>
        </div>
      </template>
      <div>
        <div style="padding: 20px 40px">
          <el-select v-model="moveFolderValue" filterable remote placeholder="输入文件夹名称搜索"
            :remote-method="fetchRemoteFolder" @focus="fetchRemoteFolder('')" :loading="fetchRemoteFolderLoading">
            <el-option v-for="item in remoteFolderOptions" :key="item.id" :label="item.origin_filename"
              :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div _flex="~ items-center justify-around" style="margin-bottom: 20px;">
          <el-button style="width:120px" @click="moveFolderDialogVisible = false">取消</el-button>
          <el-button style="width:120px" type="primary" @click="handleConfirmMoveFolder">确认</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<style>
.ResourcesDialogCustomClass{
  min-width: 1000px;
}
</style>
<style scoped lang="scss">

.flex1 {
  flex: 1;
  overflow: auto;
}

/deep/ .el-tree-node .el-tree-node__content {
  font-size: 16px;
  height: 38px;
}

/deep/.el-tree-node span.is-current {
  color: #ff5e2a;
}

/deep/ .el-dialog__header {
  border-bottom: 1px dashed #e7e7e7;
  padding: 0;
}

/deep/ .el-dialog__headerbtn {
  font-size: 36px;
  top: 16px;
  right: 16px;
}

/deep/ .el-dialog__body {
  padding: 1px 0;
}

.notEditModeBtn .el-select{
  margin-right: 10px;

}
.notEditModeBtn /deep/ .el-select input.el-input__inner{
  border: 1px solid #dcdfe6;
}

.editBtnBox /deep/ .el-button--small {
  padding: 0px 20px;
  height: 32px;
  font-size: 14px;
}

.editBtnBox /deep/ .el-button.is-plain:not(.el-button--primary):not(:disabled):hover {
  color: #666;
}

.editBtnBox /deep/ .el-button.is-plain:not(.el-button--primary):not(:disabled):focus {
  color: #666;
  border: 1px solid #dcdfe6;
}

.editBtnBox {
  position: relative;
  min-height: 32px;
}

.editModeBtn {
  transform-origin: right;
  transition: all .3s;
  position: absolute;
  top: 0;
  right: 0;
  display: flex;
  flex-direction: row;
}

.notEditModeBtn {
  transform-origin: right;
  transition: all .3s;
  position: absolute;
  top: 0;
  right: 0;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-top: -4px;
}

.selfIcon {
  max-height: 14px;
  vertical-align: bottom;
  user-select: none;
}

button[disabled] .selfIcon {
  opacity: 0.3;
}

.titleBox {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;

  .titleName {
    min-width: 200px;
    font-size: 26px;
    width: 18%;
    border-right: 1px solid #e7e7e7;
    padding: 14px 0;
    text-indent: 20px;
  }

  .searchBox {
    flex: 1;
    padding-right: 60px;
    padding-left: 40px;
  }
}

.resourceMain {
  display: flex;
  flex-direction: row;
  align-items: center;

  // 通用高度css变量
  --content-height: 62vh;

  .leftBox {
    min-width: 200px;
    width: 18%;
    height: calc(var(--content-height) + 44px);
    overflow-y: auto;
    overflow-x: hidden;
    border-right: 1px solid #e7e7e7;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .switch-textbook-btn {
      height: 44px;
      display: flex;
      align-items: center;
      justify-content: center;
      overflow: hidden;
      position: relative;

      .btn {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 16px;
        cursor: pointer;
        user-select: none;

        img {
          width: 22px;
          margin-right: 6px;
        }

        .textbookName {
          max-width: 160px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }

      &:after {
        position: absolute;
        top: 0;
        left: 0;
        content: '';
        display: block;
        width: 100%;
        height: 1px;
        background-color: #e7e7e7;
      }
    }

    .treeBox {
      flex: 1;
      overflow-y: auto;
    }
  }

  .mainBox {
    padding: 20px 0px 20px 20px;
    flex: 1;
    height: var(--content-height);
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .mainBoxTop {
      margin-bottom: 10px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-right: 20px;
    }

    .mainCtx {
      flex: 1;
    }


    .fileBox {
      display: flex;
      flex-direction: column;
    }
  }
}

.backToFolder {
  cursor: pointer;
  font-size: 20px;
  font-weight: bolder;
  padding-bottom: 10px;

  &>i {
    margin-right: 10px;
  }

  &:hover {
    color: #ff5e2a;
  }
}
</style>
